<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Writers Statistics</h1>
        <!-- <div class="tabBtns d-flex align-items-center ml-auto writers_csv">
            <button class="fltrBtn" href="javascript:;" (click)="downloadCsv()" [disabled]="downloadingFile">
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" *ngIf="!downloadingFile">
                <path d="M9.33695 15.5379C9.424 15.625 9.52736 15.694 9.6411 15.7411C9.75485 15.7882 9.87676 15.8125 9.99988 15.8125C10.123 15.8125 10.2449 15.7882 10.3587 15.7411C10.4724 15.694 10.5758 15.625 10.6628 15.5379L14.1983 12.0024C14.3741 11.8266 14.4729 11.5881 14.4729 11.3395C14.4729 11.0908 14.3741 10.8524 14.1983 10.6766C14.0225 10.5007 13.784 10.402 13.5354 10.402C13.2868 10.402 13.0483 10.5007 12.8725 10.6766L10.9374 12.6117V2.375C10.9374 2.12636 10.8386 1.8879 10.6628 1.71209C10.487 1.53627 10.2485 1.4375 9.99988 1.4375C9.75124 1.4375 9.51278 1.53627 9.33697 1.71209C9.16115 1.8879 9.06238 2.12636 9.06238 2.375V12.6117L7.12726 10.6766C6.95145 10.5007 6.71299 10.402 6.46435 10.402C6.21571 10.402 5.97726 10.5007 5.80144 10.6766C5.62563 10.8524 5.52686 11.0908 5.52686 11.3395C5.52686 11.5881 5.62563 11.8266 5.80144 12.0024L9.33695 15.5379Z" fill="#F07527"/>
                <path d="M18.125 9.5625C17.8764 9.5625 17.6379 9.66127 17.4621 9.83709C17.2863 10.0129 17.1875 10.2514 17.1875 10.5V17.6875H2.8125V10.5C2.8125 10.2514 2.71373 10.0129 2.53791 9.83709C2.3621 9.66127 2.12364 9.5625 1.875 9.5625C1.62636 9.5625 1.3879 9.66127 1.21209 9.83709C1.03627 10.0129 0.9375 10.2514 0.9375 10.5V18C0.9375 18.4144 1.10212 18.8118 1.39515 19.1049C1.68817 19.3979 2.0856 19.5625 2.5 19.5625H17.5C17.9144 19.5625 18.3118 19.3979 18.6049 19.1049C18.8979 18.8118 19.0625 18.4144 19.0625 18V10.5C19.0625 10.2514 18.9637 10.0129 18.7879 9.83709C18.6121 9.66127 18.3736 9.5625 18.125 9.5625Z" fill="#F07527"/>
              </svg>

              Loader
              <i class="fa fa-spinner fa-spin" *ngIf="downloadingFile"></i>

              <span>Download CSV File</span>
            </button>
        </div> -->
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
            <div class="filter">
              <div class="fields-m date-filter">
                <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placement="bottom left" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                  <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                  <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                  <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                  <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                  <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                  <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                  <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                  <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                  <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                  <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                  <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                  <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                  <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                  <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
                </svg>
              </div>
            </div>
            <div class="filter">
              <div class="fields-m select-m">
                <ng-select
                  [items]="writers"
                  bindLabel="name"
                  bindValue="id"
                  placeholder="All Writers"
                  [(ngModel)]="searchParams.writer_id"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="true"
                  [clearable]="true"
                  (change)="rerender()"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                      {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <div class="filter">
              <div class="fields-m select-m">
                <ng-select
                  [items]="writersCategories"
                  bindLabel="name"
                  bindValue="value"
                  placeholder="Writer Category"
                  [(ngModel)]="searchParams.region"
                  [ngModelOptions]="{standalone: true}"
                  [searchable]="false"
                  [clearable]="false"
                  (change)="rerender()"
                  >
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                      {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
              <tr>
                <th width="5%">S#</th>
                <th width="10%">Payment Date</th>
                <th width="40%">Oredr Id(s)</th>
                <th width="10%">Actual Amount</th>
                <th width="10%">Bonus Deduction</th>
                <th width="10%">Txn/Tax & turnitin charges</th>
                <th width="10%">Payment ($)</th>
                <th width="5%">Stats</th>
              </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td width="5%">{{ lead.sr }}</td>
                <td width="10%"><p class="time-done">{{ lead.payment_date | date }}</p></td>
                <td width="40%" [innerHTML]="lead.order_ids"></td>
                <td width="10%">{{ lead.actual_amount }}</td>
                <td width="10%">{{ lead.bonus }}</td>
                <td width="10%">{{ lead.charge_backs }}</td>
                <td width="10%">{{ lead.payment }}</td>
                <td width="5%" [innerHTML]="lead.stats"></td>

              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>
